import { Flex, Link, ListItem, OrderedList, UnorderedList } from '@chakra-ui/react'
import { Body1, Body1Strong } from 'components/typography'

export const medleveFaq = [
  {
    title: 'Como marcar uma consulta na Medleve?',
    body: (
      <Flex direction="column" gap={4}>
        <Body1>É só seguir estes passos simples:</Body1>
        <OrderedList>
          <ListItem>
            Insira suas informações básicas e escolha o canal de atendimento ideal. Temos duas opções:
            <UnorderedList>
              <ListItem>Videochamada: Acontece em média de até 5 minutos após o pagamento. Não precisa de agendamento.</ListItem>
              <ListItem>
                Mensagem: Funciona de forma assíncrona pela plataforma. Você escolhe o médico e não precisa agendar
                horário. O profissional responde em até 24 horas, e a conversa dura até 3 dias.
              </ListItem>
            </UnorderedList>
          </ListItem>
          <ListItem>Efetue o pagamento da consulta de forma segura e rápida via pix ou cartão de crédito.</ListItem>
          <ListItem>Responda ao formulário médico: preencha suas informações de saúde.</ListItem>
        </OrderedList>
        <Body1>
          Fique tranquilo: seguimos a Lei Geral de Proteção de Dados (LGPD) à risca e seus dados estão totalmente
          seguros.
        </Body1>
        <Body1>
          Inicie o atendimento: Crie sua senha de acesso e envie uma mensagem ao médico para começar. A consulta por
          mensagem inicia na hora e permanece aberta por até 3 dias.
        </Body1>
        <Body1>
          Se houver indicação médica após a consulta, você receberá a prescrição legal do tratamento, com assinatura
          digital e QR Code.
        </Body1>
      </Flex>
    )
  },
  {
    title: 'Como funciona uma teleconsulta por mensagem?',
    body: (
      <Flex direction={'column'} gap={4}>
        <OrderedList>
          <ListItem>Não é necessário agendar horário, porque o médico responde no máximo a cada 24h.</ListItem>
          <ListItem>
            A conversa continua até todas as informações do paciente serem recebidas e o médico concluir o diagnóstico.
          </ListItem>
          <ListItem>
            Sua conversa com o especialista sempre ficará dentro da plataforma. Isso quer dizer que você não vai receber
            o retorno do médico por WhatsApp, apenas uma notificação nossa por e-mail, informando que o especialista
            respondeu.
          </ListItem>
          <ListItem>
            Depois disso, é só entrar na plataforma e continuar a sua consulta, que pode permanecer disponível por até 3
            dias. Lembrando que você é quem manda: a consulta começa só depois do envio da sua primeira mensagem!
          </ListItem>
        </OrderedList>
        <Body1>
          Para enviar fotos ou exames, é só clicar no botão “Anexar exames” dentro da plataforma, na página de
          consultas.
        </Body1>
      </Flex>
    )
  },
  {
    title: 'Vou receber uma receita médica? Como posso usá-la?',
    body: (
      <Flex direction={'column'} gap={4}>
        <Body1>
          Se o médico indicar, após a consulta online, você receberá uma <strong>receita digital</strong>, seguindo
          todos os parâmetros do Conselho Federal de Medicina (CFM)!
        </Body1>
        <Body1>
          Ela estará disponível em seu espaço pessoal, onde você poderá acessar a prescrição e fazer o download para
          usar em uma drogaria de sua escolha ou fazer o pedido em nosso site com as farmácias oficiais parceiras
          (dependendo da região e da medicação).
        </Body1>
        <Body1>
          Nossa receita é <strong>segura e assinada digitalmente</strong>, com QR Code e código de acesso/token. A
          prescrição segue todos os padrões de certificação do ICP-Brasil, com validação pública pelo site do governo,
          ou seja, o farmacêutico ou você mesmo pode verificar online a autenticidade do documento.
        </Body1>
      </Flex>
    )
  },
  {
    title: 'Como acessar minhas prescrições?',
    body: (
      <Flex direction={'column'} gap={4}>
        <Body1>
          Para acessar sua receita, acesse seu espaço do paciente, vá para a página{' '}
          <strong>&quot;Minhas Receitas/Guias&quot;</strong> e clique em <strong>&quot;Ver Prescrição&quot;</strong>{' '}
          para fazer o download.
        </Body1>
        <Body1>
          As receitas dos nossos médicos seguem a Lei da Assinatura Digital, que garante que documentos assinados
          digitalmente têm o mesmo valor legal que um receituário assinado à mão. Por isso, elas são válidas em todo o
          território nacional.
        </Body1>
        <Body1>E, caso queira acessar seus exames, basta ir para o espaço pessoal &gt; Meus exames. </Body1>
      </Flex>
    )
  },
  {
    title: 'E se o médico achar que o tratamento não é indicado para mim?',
    body: (
      <Flex direction={'column'} gap={4}>
        <Body1>
          Não se preocupe! Nossa prioridade é sua saúde e segurança. Se o médico achar que o tratamento não é indicado
          para você, você receberá a orientação adequada, sempre com segurança e cuidado. Nossa equipe está aqui para
          ajudar e garantir que você receba o melhor atendimento possível.
        </Body1>
        <Body1>Você está em boas mãos!</Body1>
      </Flex>
    )
  },
  {
    title: 'Paguei, e agora?',
    body: (
      <Flex direction={'column'} gap={4}>
        <Body1>
          Uma vez paga a consulta, você receberá um email de convite à plataforma, com um link para definir a sua senha.
          Depois disso, basta usar seu e-mail e senha para acessar sua conta.
        </Body1>
        <Body1>Se precisar alterar a senha, é só clicar em “Esqueceu sua senha?”</Body1>
        <Body1>Não recebeu o e-mail?</Body1>
        <UnorderedList>
          <ListItem>Confira no lixo eletrônico ou no spam</ListItem>
          <ListItem>Se não encontrar, entre em contato com nosso atendimento para te ajudar.</ListItem>
        </UnorderedList>
      </Flex>
    )
  },
  {
    title: 'Como receberei o retorno do médico?',
    body: (
      <Flex direction="column" gap={4}>
        <Body1>Escolha como deseja ser atendido:</Body1>
        <UnorderedList>
          <ListItem>
            Consulta por Vídeo: Não precisa agendar. Você entra na sala virtual e é atendido em média de até 5 minutos.
          </ListItem>
          <ListItem>
            Consulta por Mensagem: O médico responde na plataforma no máximo a cada 24h. Recomendamos que você responda
            o quanto antes para otimizar seu atendimento.
          </ListItem>
        </UnorderedList>
        <Body1>
          O médico responderá às suas mensagens na plataforma, mantendo sua privacidade total. Seguimos as normas do
          Conselho Federal de Medicina e garantimos a sua segurança. Isso significa que você não receberá a resposta do
          médico pelo WhatsApp, mas você receberá uma notificação por e-mail quando o especialista responder.
        </Body1>
        <Body1>
          Basta acessar seu espaço do paciente na página de consultas para continuar a conversa. Recomendamos que você
          responda às mensagens o quanto antes para otimizar sua consulta.
        </Body1>
      </Flex>
    )
  },
  {
    title: 'Como é feito o pagamento?',
    body: (
      <Flex direction={'column'} gap={4}>
        <Body1>
          O pagamento é simples, rápido e totalmente seguro. Tanto a consulta quanto o medicamento você pode ter acesso
          utilizando <strong>cartão de crédito</strong> ou <strong>Pix</strong>.{' '}
        </Body1>
        <Body1>
          Para garantir sua organização e um atendimento sem imprevistos, o pagamento é realizado de forma antecipada.
        </Body1>
        <Body1>
          Se surgir qualquer dúvida durante o processo,{' '}
          <Link textDecoration="underline" href="https://wa.me/5511993032210" isExternal>
            nossa equipe estará pronta para te ajudar!
          </Link>
        </Body1>
      </Flex>
    )
  },
  {
    title: 'Posso fazer uma consulta para outra pessoa?',
    body: (
      <Flex direction={'column'} gap={4}>
        <Body1>Não é possível fazer uma consulta para outra pessoa. </Body1>
        <Body1>
          Sua conta na Medleve é estritamente pessoal, então as consultas são exclusivas para você. Se a pessoa precisar
          de atendimento, ela pode criar sua própria conta e agendar uma consulta.
        </Body1>
      </Flex>
    )
  },
  {
    title: 'Todo mundo pode passar por uma teleconsulta na Medleve?',
    body: <Body1>Sim. Mas, para realizar sua consulta com a gente, é necessário ter mais de 18 anos.</Body1>
  },
  {
    title: 'Aceitam plano de saúde?',
    body: (
      <Body1>
        Atualmente não trabalhamos com convênios médicos. <br />
        Mas não se preocupe! Você pode solicitar um recibo para reembolso e verificar seu contrato com o plano de saúde.
        Muitos planos permitem reembolso em valores estipulados. Se tiver dúvidas, entre em contato com o seu plano para
        saber mais.
      </Body1>
    )
  },
  {
    title: 'Consulta de retorno: tenho direito? Como funciona?',
    body: (
      <Flex direction={'column'} gap={4}>
        <Body1>
          Depois da consulta online, caso o médico julgue necessário, ele pode liberar uma consulta de retorno.
        </Body1>
        <UnorderedList>
          <ListItem>Ela estará disponível no seu espaço pessoal seguro e tem validade de 30 dias.</ListItem>
          <ListItem>É feita por mensagem, sem precisar agendar.</ListItem>
          <ListItem>Você envia uma mensagem para o médico e recebe resposta em no máximo 24 horas.</ListItem>
        </UnorderedList>
        <Body1>
          Caso precise de um acompanhamento mais próximo ou queira iniciar um novo ciclo de avaliação, você também pode
          agendar uma nova consulta de forma simples e rápida.
        </Body1>
      </Flex>
    )
  },
  {
    title: 'Meus dados pessoais estão seguros?',
    body: (
      <Flex direction={'column'} gap={4}>
        <Body1>
          Seus dados estão seguros conosco: levamos sua privacidade muito a sério! Nossa plataforma foi projetada para
          cumprir todas as leis de privacidade aplicáveis (LGPD) e temos protocolos de segurança rigorosos para proteger
          seus dados. Mantemos seguras as suas informações.
        </Body1>
      </Flex>
    )
  },
  {
    title: 'Fazer pedido na plataforma com a farmácia oficial parceira: como funciona?',
    body: (
      <Flex direction={'column'} gap={4}>
        <Body1>
          Depois da consulta online e da emissão da receita digital com assinatura eletrônica, dependendo da medicação e
          da região, você pode fazer o pedido direto pelo nosso site:
        </Body1>
        <UnorderedList>
          <ListItem>Acesse seu espaço pessoal e siga as orientações na página inicial.</ListItem>
          <ListItem>Uma de nossas farmácias oficiais parceiras entregará no conforto da sua casa.</ListItem>
        </UnorderedList>
        <Body1Strong>Importante:</Body1Strong>
        <UnorderedList>
          <ListItem>
            Conforme a Portaria 344/1998, não é permitida a devolução ou troca de medicamentos controlados/refrigerados.
          </ListItem>
        </UnorderedList>
      </Flex>
    )
  },
  {
    title: 'Entrega do seu pedido: como funciona?',
    body: (
      <Flex direction="column" gap={4}>
        <Body1>
          Você recebe seu pedido em casa com total comodidade, sem burocracia e sem sair de casa. Seu pedido é enviado
          de forma segura e refrigerada por transportadoras especializadas.
        </Body1>
        <Body1>Prazo de Entrega (após a postagem):</Body1>
        <Body1>A partir de 36h úteis (dependendo da cidade).</Body1>
        <Body1>Em caso de dúvidas, entre em contato com o nosso suporte.</Body1>
      </Flex>
    )
  },
  {
    title: 'Posso cancelar meu pedido?',
    body: (
      <Body1>
        Conforme a Portaria 344/1998, não é permitida a devolução ou troca de medicamentos controlados/refrigerados.
      </Body1>
    )
  }
]
